import {OfferDisplayType} from "../../../helpers/OfferDisplayType";
import {GTMEcommerceAvailability} from "../types/gtm_ecommerce_availability";

export interface IGtmEcommerceOfferAvailabilityParams {
    configuration: {
        display_type?: OfferDisplayType;
        limited_presentation?: boolean;
    };
}

export const getGtmEcommerceOfferAvailability = (params: IGtmEcommerceOfferAvailabilityParams) => {
    const isForSale = !params.configuration?.display_type || params.configuration.display_type === OfferDisplayType.FOR_SALE;
    const isLimitedPresentation = !!params.configuration?.limited_presentation;
    return {
        availability: isForSale && !isLimitedPresentation ? GTMEcommerceAvailability.IN_STOCK : GTMEcommerceAvailability.OUT_OF_STOCK
    };
};
import {OfferDisplayType} from "../../../helpers/OfferDisplayType";
import {GTMEcommerceAvailability} from "../types/gtm_ecommerce_availability";

export interface IGtmEcommerceOfferAvailabilityParams {
    configuration: {
        display_type?: OfferDisplayType;
        limited_presentation?: boolean;
    };
}

export const getGtmEcommerceOfferAvailability = (params: IGtmEcommerceOfferAvailabilityParams) => {
    const isForSale = !params.configuration?.display_type || params.configuration.display_type === OfferDisplayType.FOR_SALE;
    const isLimitedPresentation = !!params.configuration?.limited_presentation;
    return {
        availability: isForSale && !isLimitedPresentation ? GTMEcommerceAvailability.IN_STOCK : GTMEcommerceAvailability.OUT_OF_STOCK
    };
};
